import { FaRemoveFormat } from "react-icons/fa";
import { useGetEditor } from "../../../context/useEditorContext";
import { IconsContainer } from "./IconsContainer";
import { Seperator } from "./Seperator";
import { TopButton } from "./TopButton";
import { Editor } from "@tiptap/react";

export function RemoveFormatting() {
    const editor = useGetEditor().editor.current;
    return (
        <IconsContainer>
            <TopButton
                alt="Remove formatting"
                icon={<FaRemoveFormat size={16} />}
                onClick={(e) => {
                    if (!editor || editor?.state.selection.empty) return;

                    removeFormattingFromSelection(editor);
                }}
            />
            <Seperator />
        </IconsContainer>
    );
}

function removeFormattingFromSelection(editor: Editor) {
    const { state, view } = editor;
    const { from, to } = state.selection;

    // Example: Get selected plain text
    const plainText = state.doc.textBetween(from, to, "\n");

    editor
        .chain()
        .focus()
        // .clearNodes()
        .unsetAllMarks()
        .resetAttributes("paragraph", ["style", "class"])
        .deleteSelection() // optional, but ensures clean replacement
        .insertContent(plainText) // plain text string
        .run();
}
